// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","cardText":"Card_cardText__ffTRN","cardId":"Card_cardId__f+UES","icons":"Card_icons__HdryQ","deleteButton":"Card_deleteButton__rJRLQ"};